import Image from 'next/image';
import React from 'react';

import ListingIcon from '@app/components/icons/ListingIcon';
import TransactionIcon from '@app/components/icons/TransactionIcon';
import VerifyIcon from '@app/components/icons/VerifyIcon';
import { cn } from '@app/libs/utils';

interface ServicesSectionProps {
  className?: string;
}

export const ServicesSection: React.FC<ServicesSectionProps> = ({ className }) => {
  const items = [
    {
      key: 'listing',
      title: 'Dịch vụ đăng tin rao bán bất động sản',
      description:
        'Đăng tin nhanh chóng, quản lý tin hiệu quả và tiếp cận đúng khách hàng mục tiêu.',
      icon: <ListingIcon />,
    },
    {
      key: 'verify',
      title: 'Nền tảng xác thực bất động sản',
      description:
        'Xác minh thông tin tài sản, hồ sơ pháp lý và tính xác thực minh bạch, nhanh chóng.',
      icon: <VerifyIcon />,
    },
    {
      key: 'transaction',
      title: 'Giao dịch mua bán trực tuyến',
      description:
        'Đặt lịch, thương lượng và ký kết trực tuyến an toàn, bảo mật, nhanh chóng và hiệu quả.',
      icon: <TransactionIcon />,
    },
  ];

  return (
    <section className={cn('w-full flex justify-center', className)}>
      <div className="2xl:w-[90rem] w-full mx-auto px-5 py-16">
        {/* Heading */}
        {/* Header: gap ~12px, margin-bottom ~40px */}
        <div className="flex flex-col items-center gap-4 text-center mb-10">
          <span className="text-sm font-semibold tracking-wide uppercase text-gray-500">
            Dịch vụ
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
            Giải pháp giao dịch bất động sản trực tuyến
          </h2>
        </div>

        {/* Cards */}
        {/* Grid gap ~30px → dùng gap-8 (~32px) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map(item => (
            <div
              key={item.key}
              className="rounded-xl border border-gray-200 bg-white p-8 transition-all hover:shadow-xl hover:text-blue-800 flex flex-col items-center justify-center"
            >
              {/* Icon container ~56px, icon 24px, căn giữa tuyệt đối */}
              <div className="h-14 w-14 flex items-center justify-center mb-5 shrink-0 transition-all">
                {React.cloneElement(item.icon as any, { width: 60, height: 60 })}
              </div>
              <h3 className="text-md font-semibold mb-3 text-center transition-all">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-center text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
